<template>
  <div>
    <profile-modal
      v-if="isPowerUserOrAdministrator"
      :show="showProfileModal"
      :current-operation="currentOperation"
      :profile="profile"
      :linked-entity-id="linkedEntityId"
      :type="type"
      @close="closeProfileModal"
    />

    <p>
      Liste des thèmes
      <button
        v-if="isPowerUserOrAdministrator"
        v-show="!editingDisabled"
        id="btn-add"
        type="button"
        class="btn btn-icon btn-round btn-success"
        aria-label="Ajouter un thème"
        @click="createProfile"
      >
        <i class="fa fa-plus" />
      </button>
    </p>
    <div class="row text-left">
      <div v-for="(profile, index) in profiles" :key="index" class="col-md-3">
        <div
          :class="{ 'clickable-element': !editingDisabled }"
          class="profile-card"
          @click="profileCardClicked(profile, $event)"
        >
          <b>{{ profile.profileCategory }}</b
          ><br />
          {{ profile.profileName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import ProfileModal from 'src/components/ApplicationViews/Modals/ProfileModal.vue';

export default {
  name: 'ProfilesCards',
  components: {
    ProfileModal,
  },
  props: {
    profiles: Array,
    editingDisabled: Boolean,
    type: String,
    linkedEntityId: Number,
    fetch: Function,
  },
  data() {
    return {
      showProfileModal: false,
      currentOperation: null,
      profile: {},
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  methods: {
    profileCardClicked(profile, event) {
      if (this.editingDisabled) {
        event.stopPropagation();
      } else {
        this.currentOperation = 'delete';
        this.profile = profile;
        this.showProfileModal = true;
      }
    },
    createProfile() {
      this.currentOperation = 'create';
      this.profile = {
        profileId: null,
      };
      this.showProfileModal = true;
    },
    closeProfileModal() {
      this.showProfileModal = false;
      this.fetch(this.linkedEntityId);
    },
  },
};
</script>

<style scoped>
.profile-card {
  background-color: lightblue;
  padding: 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 10px;
}
</style>
